import styled from "styled-components";

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${({ theme }) => theme.colors.black + "66"};
  z-index: 50;

  &.animation-enter {
    opacity: 0;
  }
  &.animation-exit {
    opacity: 1;
  }
  &.animation-enter-active {
    opacity: 1;
  }
  &.animation-exit-active {
    opacity: 0;
  }
  &.animation-enter-active,
  &.animation-exit-active {
    transition: opacity 200ms;
  }
`;

export const Container = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.tablet} {
    left: unset;
    width: 30rem;
  }
`;
